import { createActions } from 'src/utils/createActions';

export const SAVE_PROJECT = createActions<{
  email: string;
}, void>('SAVE_PROJECT');
